
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Ensure proper mounting of the application
const container = document.getElementById("root");
if (!container) throw new Error("No root element found");

const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
